import { render, staticRenderFns } from "./TeamInvitation.vue?vue&type=template&id=00f32642&scoped=true"
import script from "./TeamInvitation.vue?vue&type=script&lang=ts"
export * from "./TeamInvitation.vue?vue&type=script&lang=ts"
import style0 from "./TeamInvitation.vue?vue&type=style&index=0&id=00f32642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f32642",
  null
  
)

export default component.exports